import nl2br from './nl2br';

export class Nl2BrValueConverter
{

    toView(str)
    {
        return nl2br(str);
    }

}
